module.exports = __webpack_public_path__ + "static/img/blog-2.62ceed7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/interthings/blog-2.jpg
// module id = toFj
// module chunks = 4